var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSwapRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.896 12.552l2 4a1 1 0 01-1.79.895l-.834-1.669C19.787 19.5 16.216 22 12.001 22c-4.581 0-8.675-2.957-9.957-7.191a1 1 0 011.914-.58C4.986 17.628 8.294 20 12 20c3.49 0 6.348-2.029 7.483-5.123l-2.036 1.018a1 1 0 11-.894-1.79l4-2a1 1 0 011.342.448zM12 2c4.58 0 8.674 2.956 9.957 7.19a1 1 0 01-1.914.58C19.014 6.372 15.707 4 12 4 8.508 4 5.65 6.03 4.515 9.123l2.039-1.018a1 1 0 01.894 1.789l-4 2a1.003 1.003 0 01-1.342-.447l-2-4a1 1 0 011.79-.895l.832 1.667C4.211 4.5 7.783 2 12.001 2z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconSwapRounded;